import React from "react";

// Create the context with default values
const StyleContext = React.createContext({
  isDark: false,
  changeTheme: () => {}
});

// Create a provider component
const StyleContextProvider = ({ children, value }) => {
  // Always initialize state
  const [isDark, setIsDark] = React.useState(false);

  // Effect to load dark mode preference
  React.useEffect(() => {
    const darkPref = localStorage.getItem("isDark");
    if (darkPref !== null) {
      setIsDark(JSON.parse(darkPref));
    }
  }, []);

  // Theme toggle function
  const changeTheme = () => {
    setIsDark(!isDark);
    localStorage.setItem("isDark", !isDark);
  };

  // Use either provided value or internal state
  const contextValue = value || { isDark, changeTheme };

  return (
    <StyleContext.Provider value={contextValue}>
      {children}
    </StyleContext.Provider>
  );
};

export { StyleContextProvider };
export default StyleContext;
